import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Hacé tu compra segura',
  desc: 'Recibís acceso inmediato por email a todo el material.'
}, {
  num: '02',
  title: 'Descargá e imprimí',
  desc: 'Todos los moldes en PDF, listos para usar en tu casa.'
}, {
  num: '03',
  title: 'Creá y emprendé',
  desc: 'Cosé hermosos diseños y comenzá tu propio negocio.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white" data-id="element-193">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-196">
            Empezá en <span className="text-brand-rose" data-id="element-197">3 simples pasos</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-198">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 border-t-2 border-dashed border-brand-pink-mid -z-10" data-id="element-199"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-brand-cream-light/50 p-8 rounded-3xl" data-id="element-200">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-soft-pink mb-6 text-brand-rose font-script text-5xl" data-id="element-201">
                {step.num}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-202">{step.title}</h3>
              <p className="text-brand-brown/80" data-id="element-203">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}